import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { EnumLanguages, EnumScreenSizes } from "./sysenums.enum";
import { SysGlobals } from './sysglobals';

@Injectable({
    providedIn: 'root',
})
export class ScreenService {

    private _currentScreenSize: EnumScreenSizes;

    private onScreenSizeChanged: BehaviorSubject<EnumScreenSizes> = new BehaviorSubject(this.GetScreenSize());
    // private onScreenSizeChanged: ReplaySubject<EnumScreenSizes> = new ReplaySubject(1);
    readonly ScreenSize$ = this.onScreenSizeChanged.asObservable();

    public get Sizes() {
        return {
            'screen-x-small': this.breakpointObserver.isMatched(Breakpoints.XSmall),
            'screen-small': this.breakpointObserver.isMatched(Breakpoints.Small),
            'screen-medium': this.breakpointObserver.isMatched(Breakpoints.Medium),
            'screen-large': this.breakpointObserver.isMatched(Breakpoints.Large),
            'screen-x-large': this.breakpointObserver.isMatched(Breakpoints.XLarge)
        };
    }

    //Subscribe to size changes
    constructor(private breakpointObserver: BreakpointObserver) {
        // this.onScreenSizeChanged.next(this.GetScreenSize());
        //
        this.breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
            .subscribe(() => {
                const newSize = this.GetScreenSize();
                if (newSize !== this._currentScreenSize) {
                    this._currentScreenSize = newSize;
                    this.onScreenSizeChanged.next(this._currentScreenSize);
                }
             });
    }

    //Return relevant screen size
    public GetScreenSize(): EnumScreenSizes {
        if (this.breakpointObserver.isMatched(Breakpoints.XSmall)) return EnumScreenSizes.ScreenXSmall;
        if (this.breakpointObserver.isMatched(Breakpoints.Small)) return EnumScreenSizes.ScreenSmall;
        if (this.breakpointObserver.isMatched(Breakpoints.Medium)) return EnumScreenSizes.ScreenMedium;
        if (this.breakpointObserver.isMatched(Breakpoints.Large)) return EnumScreenSizes.ScreenLarge;
        if (this.breakpointObserver.isMatched(Breakpoints.XLarge)) return EnumScreenSizes.ScreenXLarge;
    }

    public IsRTL(): boolean {
        return (SysGlobals.Language == EnumLanguages.Hebrew)
    }

    public IsMobile() {
        var size = this.GetScreenSize();
        // return size == EnumScreenSizes.ScreenXSmall || size == EnumScreenSizes.ScreenSmall;
        return size == EnumScreenSizes.ScreenXSmall;
    }

    public IsDesktop() {
        return !this.IsMobile();
        //const isLarge = this.breakpointObserver.isMatched(Breakpoints.Large);
        //const isXLarge = this.breakpointObserver.isMatched(Breakpoints.XLarge);

        //return isLarge || isXLarge;
    }

    public IsPrintMode(): boolean {
        return window.matchMedia('print').matches;
    }
}
